<script>
  import {getContext, onMount} from 'svelte';
  import QRCode from 'qrcode';
  import Menu from '@/widgets/trigger/Menu.svelte';
  import {aspectRatio$} from '@/streams/window-inner-size';
  import {map} from 'rxjs/operators';

  const LG = getContext('LG');

  export let url;
  export let img;
  export let type;

  let imgLoaded = false;
  let qrcodeUrl;
  let isAndroid;
  let isIOS;

  onMount(() => {
    const imgObj = new Image();
    imgObj.src = img;
    imgObj.onload = function () {
      imgLoaded = true;
    };
    const sub = aspectRatio$.subscribe(async (ratio) => {
      qrcodeUrl = await QRCode.toDataURL(url, {
        width: 280 * ratio,
        margin: 5 * ratio,
      });
    });
    checkEnvType();
    return function () {
      sub.unsubscribe();
    };
  });

  const placement = 'top-start';
  const modifiers$ = aspectRatio$.pipe(
    map((ratio) => {
      return [
        {
          name: 'offset',
          options: {
            offset: [-100 * ratio, 10 * ratio],
          },
        },
        {
          name: 'preventOverflow',
          options: {
            padding: 40 * ratio,
          },
        },
      ];
    })
  );

  function checkEnvType() {
    const u = navigator.userAgent;
    isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
    isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  }
</script>

<style>
  .app-download-btn {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: calc(var(--aspect-ratio) * 32px);
    width: calc(var(--aspect-ratio) * 64px);
    height: calc(var(--aspect-ratio) * 64px);
    background: #f0f1f5;
    cursor: pointer;
  }
  .img {
    height: calc(var(--aspect-ratio) * 32px);
  }
  @media screen and (max-width: 640px) {
    .android-env .android {
      display: block;
    }
    .android-env .ios {
      display: none;
    }
    .ios-env .android {
      display: none;
    }
    .ios-env .ios {
      display: block;
    }
  }
</style>

<div class="btn-wrapper" class:android-env={isAndroid} class:ios-env={isIOS}>
  <Menu {placement} modifiers={$modifiers$} noIcon>
    <div slot="trigger" class="icon-con df aic cp fw1" class:android={type === 'Android'} class:ios={type === 'IOS'}>
      {#if imgLoaded}
        <a href={url} target="_blank" rel="noopener noreferrer nofollow" class="app-download-btn">
          <img class="img" src={img} />
        </a>
      {/if}
    </div>
    <img class="qrcode lazyload" alt="qr code" data-src={qrcodeUrl} />
  </Menu>
</div>
